import * as React from 'react';

import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { Translate } from 'react-localize-redux';

import styled from 'styled-components';

import AppState from '@webapp/store/state';

import SimpleArtist from '@common/types/artist/simple-artist';
import * as releaseValidators from '@webapp/utils/validators/release';

import SidebarCtrl, { SidebarSection } from '../../sidebar';
import TrackSidebar from '@webapp/controllers/release/track-sidebar';
import NavbarItemAvatarCtrl from '@webapp/controllers/navbar/navbar-actions/navbar-items/navbar-item-avatar';

interface ReleaseSidebarCtrlProps {
  className?: string;
  activeArtist?: SimpleArtist;

  releaseId?: string;

  isTitleSectionValid: boolean;
  isDetailsSectionValid: boolean;
  isDatesSectionValid: boolean;

  isPublished: boolean;

  isMobile: boolean;
}

const mapStateToProps = (state: AppState) => ({
  releaseId: state.release.release?.id,
  activeArtist: state.artist.active,
  isPublished:
    state.release.release?.isPublished ||
    state.release.release?.status === 'pending-processing',
  isTitleSectionValid: releaseValidators.titleSection(state),
  isDetailsSectionValid: releaseValidators.detailsSection(state),
  isDatesSectionValid: releaseValidators.datesSection(state),

  isMobile: state.ui.mobile,
});

export const ReleaseSidebarCtrl: React.FC<ReleaseSidebarCtrlProps> = (
  props
) => {
  const location = useLocation();

  const isReleaseSection = () => {
    return location.pathname.startsWith('/release/');
  };

  const getRoute = (section: string) => {
    const artistId = props.activeArtist?.id;
    const releaseId = props.releaseId;

    return (
      '/' +
      ['release', artistId, releaseId, section].filter((f) => !!f).join('/')
    );
  };

  const isDone = (section: string) => {
    switch (section) {
      case 'title':
        return props.isTitleSectionValid;
      case 'details':
        return props.isDetailsSectionValid;
      case 'dates':
        return props.isDatesSectionValid;
    }

    return false;
  };

  const sections: SidebarSection[] = [
    {
      path: getRoute('title'),
      label: <Translate id="RELEASE.SIDEBAR.LIST.COVER_MUSIC" />,
      done: isDone('title'),
      disabled: false,
      // TODO: DEVTEAM-958 - Integrate step errors here
      // error: false,
    },
    {
      path: getRoute('details'),
      label: <Translate id="RELEASE.SIDEBAR.LIST.NAMES_GENRES" />,
      done: isDone('details'),
      disabled: !(isDone('title') && props.releaseId),
      // TODO: DEVTEAM-958 - Integrate step errors here
      // error: false,
    },
    {
      path: getRoute('dates'),
      label: <Translate id="RELEASE.SIDEBAR.LIST.DATES_STORES" />,
      done: isDone('dates'),
      disabled: !(isDone('details') && props.releaseId),
      // TODO: DEVTEAM-958 - Integrate step errors here
      // error: false,
    },
  ];

  if (!isReleaseSection()) {
    return null;
  }

  return (
    <div className={props.className}>
      {props.isMobile ? (
        <StyledNavbarItemAvatarCtrl
          className="navbar-artist-mobile"
          noHover
          noIcons
          noTruncate
        />
      ) : null}
      <SidebarCtrl
        title={<Translate id="RELEASE.SIDEBAR.TITLE" />}
        sections={sections}
      />
      <TrackSidebar
        location={location}
        className="track-sidebar"
        disabled={!(isDone('details') && props.releaseId)}
        disableRemove={props.isPublished}
        disableAddMore={props.isPublished}
        disableSorting={props.isPublished}
      />
    </div>
  );
};

export default connect(mapStateToProps)(styled(ReleaseSidebarCtrl)`
  .track-sidebar {
    margin-top: 30px;
  }
`);

const StyledNavbarItemAvatarCtrl = styled(NavbarItemAvatarCtrl)`
  padding: 0;
  margin-bottom: 30px;
`;
